import { createRoute } from "@tanstack/react-router";

import { QuotesContent } from "../components/screens/QuotesContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/quotes",
  component: QuotesContent,
});
